let categoryPrefix = 'cdu_carousel_'

function getScreenfromName (name) {
  var result = ''

  if (name.indexOf(categoryPrefix)) {
    result = name.toLowerCase().substring(categoryPrefix.length)
  }

  return result
}

function getHeadlinesForScreen (boNavigationHeadlines, screenId) {
  var result = []
  var category = categoryPrefix.concat(screenId.toLowerCase())

  if (boNavigationHeadlines && boNavigationHeadlines.length > 0) {
    boNavigationHeadlines.forEach(headline => {
      if (headline.categoryname && headline.categoryname.toLowerCase() === category) {
        result.push(headline)
      }
    })
  }

  return result
}

export default {
  getScreenfromName,
  getHeadlinesForScreen
}



// WEBPACK FOOTER //
// ./src/library/cdu/templates/carousel.js